import { Features } from "./features";

// `ng build -c alpha` environment
export const environment = {
  production: true,
  name: 'alpha',
  activationPath: 'https://test-mims.westus2.cloudapp.azure.com',
  platformName: 'MIMs Platform (alpha)',
  platformUrl: "https://mimsomicalpha.mims.ai",
  apiBasePath: 'https://test-mims.westus2.cloudapp.azure.com',
};
export const availableFeatures = [
  Features.MultiCountry,
  // Features.DoubleAuth,
  Features.UploadFile,
  Features.DeleteFile,
  Features.KnowledgeSearch, 
  Features.DeleleMultipleFiles,
  Features.MoveManuallyToGroup

]
